import React from 'react'
import t from 'prop-types'

import { Util, Flashcards, BotonImagen } from 'ibook-api'

const sessionStorageKey = 'pantalla-game-generator-seleccionar-flashcards-last-state'
class Pantalla extends React.Component {
    static propTypes = {
        plantillaId: t.string.isRequired,
        zonaId: t.string.isRequired,
        minFC: t.number.isRequired, // num minimo de fc que hay que seleccionar

        titulo: t.string.isRequired,
        textoPasoPrevio: t.string.isRequired,
        textoSeleccionarImagenes: t.string.isRequired, // Select images
        textoSeleccionarTodo: t.string.isRequired, // Select All
        textoSeleccionarNada: t.string.isRequired, // Clear Selection
        textoEliminarSeleccionados: t.string.isRequired, // Delete Selection
        textoAgregar: t.string.isRequired, // Agregar
        textoContinuar: t.string.isRequired,
        textoAtras: t.string.isRequired,
        textoPlaceHolderTemas: t.string.isRequired,
        textoAviso: t.arrayOf(t.string), // elemento 0 => singular, elemento 1 => plural, # marcador de posicion para variable minFC
        textoTips: t.string,
        logo: t.string, 
        fondoCabecera: t.string,

        visualizacionComboUnidades: t.string,
        modoVisualizacionComboUnidades: t.string,
        visualizacionBotonesLetras: t.string,
        visualizacionBotonesUnidades: t.string,
        rutaDatosMiniaturas: t.string,

        onContinuar: t.func.isRequired,
        onAtras: t.func.isRequired,
        onTip: t.func.isRequired,
        onVolverAMenu: t.func.isRequired
    }

    constructor(props) {
        super(props)

        const lastState = JSON.parse(Util.sessionStorage.getItem(sessionStorageKey) || "{}")
        
        this.state = {
            temas: null,
            orden: null,

            datos: [],
            datosSeleccionados: [],

            fcs: [],
            fcsSeleccionados: [],

            ...lastState
        }
    }

    handleChangeDatos = (datos) => {
        const datosSeleccionados = datos.map( () => false )
        this.setState({datos, datosSeleccionados })
    }

    handleSeleccionarDato = (index) => {
        const datosSeleccionados = [...this.state.datosSeleccionados]
        datosSeleccionados[index] = !datosSeleccionados[index]
        this.setState({datosSeleccionados})
    }

    handleSeleccionarFc = (index) => {
        const fcsSeleccionados = [...this.state.fcsSeleccionados]
        fcsSeleccionados[index] = !fcsSeleccionados[index]
        this.setState({fcsSeleccionados})
    }

    handleAgregarSeleccionadas = () => {
        const { datos, datosSeleccionados } = this.state
        
        const fcsSet = new Set(this.state.fcs)
        datosSeleccionados.forEach( (seleccionada, index) => seleccionada && fcsSet.add(datos[index]) )
        
        const fcs = Array.from(fcsSet)
        this.setState({
            fcs,
            fcsSeleccionados: fcs.map(() => false),
            datosSeleccionados: datosSeleccionados.map( () => false )
        })
    }

    handleSeleccionarTodoDatos = () => {
        this.setState({
            datosSeleccionados: this.state.datosSeleccionados.map( () => true )
        })
    }

    handleSeleccionarNadaDatos = () => {
        this.setState({
            datosSeleccionados: this.state.datosSeleccionados.map( () => false )
        })
    }

    handleSeleccionarNadaFcs = () => {
        this.setState({
            fcsSeleccionados: this.state.fcsSeleccionados.map( () => false )
        })
    }

    handleSeleccionarTodoFcs = () => {
        const { fcsSeleccionados } = this.state
        this.setState({
            fcsSeleccionados: fcsSeleccionados.map( () => true )
        })
    }

    handleEliminarSeleccionFcs = () => {
        const { fcs, fcsSeleccionados } = this.state
        const fcsRestantes = fcs.filter( (fcs, index) => !fcsSeleccionados[index] )
        this.setState({
            fcs: fcsRestantes,
            fcsSeleccionados: fcsRestantes.map( () => false )
        }) 
    }

    handleContinuar = () => {
        Util.sessionStorage.setItem(sessionStorageKey, JSON.stringify(this.state) )
        const { zonaId, plantillaId, onContinuar } = this.props
        const { fcs } = this.state
        const { libroId, numPagina, numZona } = Util.decodificarZonaId(zonaId)
        onContinuar(libroId, numPagina, numZona, plantillaId, fcs)
    }

    handleAtras = () => this.props.onAtras()

    handleVolverAMenu = () => this.props.onVolverAMenu()

    handleTip = () => this.props.onTip()

    componentDidMount() {
        const { temas, orden } = this.state
        if (temas && orden) {
            return
        }
        const rutaJSONgrupos = this.props.rutaDatosMiniaturas || 'contenido/FCs/flashcards'
        // const rutaJSONgrupos = 'contenido/GG/curso'
        // fetch('contenido/FCs/flashcards/grp.json')
        Util.fetch(rutaJSONgrupos + '/grp.json')
            .then(response => response.json())
            .then(json => {
                const { TEMAS: temas, ORDEN: orden } = json.data
                this.setState({ temas, orden })
            })
    }

    getNumDatosSeleccionados = () => {
        const { datosSeleccionados } = this.state
        return datosSeleccionados.reduce( (previousValue, currentValue) => { 
                return currentValue ? previousValue + 1 : previousValue 
            }, 0
        )
    }

    getNumFcsSeleccionados = () => {
        const { fcsSeleccionados } = this.state
        return fcsSeleccionados.reduce( (previousValue, currentValue) => { 
                return currentValue ? previousValue + 1 : previousValue 
            }, 0
        )
    }

    renderAviso() {        
        const { textoAviso, minFC } = this.props
        const { fcsSeleccionados } = this.state
        if (fcsSeleccionados.length >= minFC ) {
            return null
        }

        const aviso = minFC > 1 ? textoAviso[1] : textoAviso[0]
        return <div className="cajaAvisosSelectorImagenes"><span>{aviso.split('#').join(minFC)}</span></div>
    }

    render() {
        const { minFC, titulo, logo, fondoCabecera,
            textoSeleccionarImagenes, textoPlaceHolderTemas,
            textoPasoPrevio, 
            textoSeleccionarTodo, textoSeleccionarNada, 
            textoAgregar, textoAtras, 
            textoEliminarSeleccionados, textoUsarSeleccionados, 
            visualizacionComboUnidades, modoVisualizacionComboUnidades, visualizacionBotonesLetras, visualizacionBotonesUnidades,
            rutaDatosMiniaturas,
            botonesContenedor_nexoCajasMiniaturas, botonesContenedor_controlesSeleccion, botonesContenedor_botoneraInferiorSelector, botonesContenedor_botoneraCajaMiniaturas,
            textoTips } = this.props 
            
        const { temas, orden, datos, datosSeleccionados, fcs, fcsSeleccionados } = this.state
        const numDatosSeleccionados = this.getNumDatosSeleccionados()
        const numFcsSeleccionados = this.getNumFcsSeleccionados()

        const renderBotonPasoMiniaturas = <BotonImagen clases='botonPasoMiniaturas' desactivado={ numDatosSeleccionados === 0 } onClick={ this.handleAgregarSeleccionadas }>{ textoAgregar }</BotonImagen>
        const renderCajaAvisosSelectorImagenes = this.renderAviso ()
        const renderBotonEliminarSeleccion = <BotonImagen clases='botonEliminarSeleccion' desactivado={ numFcsSeleccionados === 0 } onClick={ this.handleEliminarSeleccionFcs } >{ textoEliminarSeleccionados }</BotonImagen>
        const renderBotonUsarSeleccion = <BotonImagen clases='botonUsarSeleccion' desactivado={ fcsSeleccionados.length < minFC } onClick={ this.handleContinuar } >{ textoUsarSeleccionados }</BotonImagen>
        const renderBotonPasoAtras = <BotonImagen clases='botonPasoAtras' onClick={ this.handleAtras } >{ textoPasoPrevio }</BotonImagen>
        const renderVolverAMenu = <BotonImagen clases='volverAMenu' onClick={ this.handleVolverAMenu } >{ textoAtras }</BotonImagen>
        const renderBotonSeleccionarTodo = <Flashcards.BotonCajaMiniaturas desactivado={ fcs.length === 0 || fcs.length === numFcsSeleccionados } onClick={ this.handleSeleccionarTodoFcs } >{ textoSeleccionarTodo }</Flashcards.BotonCajaMiniaturas>
        const renderBotonDeseleccionarTodo = <Flashcards.BotonCajaMiniaturas desactivado={ numFcsSeleccionados === 0 } onClick={ this.handleSeleccionarNadaFcs } >{ textoSeleccionarNada }</Flashcards.BotonCajaMiniaturas>
        const rutaFCs = rutaDatosMiniaturas || 'contenido/FCs/flashcards'

        if (temas === null || orden === null) {
            return <div>loading...</div>
        }

        return (
            <div className="fondoMenus">
                <div className="selectorImagenes generador">
                    <div className="cabeceraSelector">
                        { logo !== false && <div className="logo"></div> }
                        { fondoCabecera && <img src={ fondoCabecera } alt="" /> }
                        <div className="titulo" dangerouslySetInnerHTML={{ __html: titulo }} />
                        <BotonImagen clases='paso1cabecera' onClick={ this.handleAtras } />
                        <div className='paso2cabecera boton2estados botonIndicador' />
                        <BotonImagen clases='botonIndicaciones' onClick={ this.handleTip }>{ textoTips }</BotonImagen>
                    </div>
                    <div className="columnaSeleccion">
                        { visualizacionComboUnidades && modoVisualizacionComboUnidades!=='div' && <Flashcards.Temas modoCombo={ true } titulo="" placeHolder={ textoPlaceHolderTemas } temas={ temas } datos={ datos } onDatos={ this.handleChangeDatos } /> }
                        { visualizacionComboUnidades && modoVisualizacionComboUnidades==='div' && <Flashcards.Temas modoCombo={ false } titulo="" placeHolder={ textoPlaceHolderTemas } temas={ temas } datos={ datos } onDatos={ this.handleChangeDatos } /> }
                        { visualizacionBotonesLetras && <Flashcards.Letras orden={ orden } onDatos={ this.handleChangeDatos } /> }
                        <span className="descripcionPaso">{ textoSeleccionarImagenes }</span>                        
                        <div className="seleccionSuperior">                        
                            <div className="cabeceraCajaMiniaturas">
                                { visualizacionBotonesUnidades && <Flashcards.Unidades unidades={ temas } datos={ datos } onDatos={ this.handleChangeDatos } /> }
                            </div>                            
                            <Flashcards.CajaMiniaturas 
                                flashcards={ datos } 
                                seleccionadas={ datosSeleccionados } 
                                onSeleccionar={ this.handleSeleccionarDato }
                                ruta={ rutaFCs } 
                            />
                            <div className="botoneraCajaMiniaturas">
                                <Flashcards.BotonCajaMiniaturas desactivado={ datos.length === 0 || datos.length === numDatosSeleccionados } onClick={ this.handleSeleccionarTodoDatos } >{ textoSeleccionarTodo }</Flashcards.BotonCajaMiniaturas>
                                <Flashcards.BotonCajaMiniaturas desactivado={ numDatosSeleccionados === 0 } onClick={ this.handleSeleccionarNadaDatos } >{ textoSeleccionarNada }</Flashcards.BotonCajaMiniaturas>
                            </div>
                        </div>
                        <div className="nexoCajasMiniaturas">
                            { botonesContenedor_nexoCajasMiniaturas && botonesContenedor_nexoCajasMiniaturas.map(i => eval('render' + i.charAt(0).toUpperCase() + i.substring(1))) }
                            { !botonesContenedor_nexoCajasMiniaturas && renderBotonPasoMiniaturas }
                            { !botonesContenedor_nexoCajasMiniaturas && renderCajaAvisosSelectorImagenes }
                        </div>
                        <div className="seleccionInferior">
                            <div className="cabeceraCajaMiniaturas"></div>
                            <Flashcards.CajaMiniaturas
                                flashcards={ fcs } 
                                seleccionadas={ fcsSeleccionados } 
                                onSeleccionar={ this.handleSeleccionarFc } 
                                ruta={ rutaFCs } 
                            />
                            <div className="botoneraCajaMiniaturas">
                                { botonesContenedor_botoneraCajaMiniaturas && botonesContenedor_botoneraCajaMiniaturas.map(i => eval('render' + i.charAt(0).toUpperCase() + i.substring(1))) }
                                { !botonesContenedor_botoneraCajaMiniaturas && renderBotonSeleccionarTodo }
                                { !botonesContenedor_botoneraCajaMiniaturas && renderBotonDeseleccionarTodo }
                            </div>
                        </div>                    
                        <div className="controlesSeleccion">
                            { botonesContenedor_controlesSeleccion && botonesContenedor_controlesSeleccion.map(i => eval('render' + i.charAt(0).toUpperCase() + i.substring(1))) }
                            { !botonesContenedor_controlesSeleccion && renderBotonEliminarSeleccion }
                            { !botonesContenedor_controlesSeleccion && renderBotonUsarSeleccion }
                        </div>
                    </div>
                    <div className="botoneraInferiorSelector">
                        { botonesContenedor_botoneraInferiorSelector && botonesContenedor_botoneraInferiorSelector.map(i => eval('render' + i.charAt(0).toUpperCase() + i.substring(1))) }
                        { !botonesContenedor_botoneraInferiorSelector && renderBotonPasoAtras }
                        { !botonesContenedor_botoneraInferiorSelector && renderVolverAMenu }
                    </div>
                </div>
            </div>
        )
    }
}

export default Pantalla